module.exports = __webpack_public_path__ + "img/qy-wx.6b32a1f7.png";